import React from "react";
import NotAllowed from "./NotAllowed";

export type ProtectedProps = {
  isAuthorized?: boolean;
  outlet: React.JSX.Element;
};

export default Protected;

function Protected({ isAuthorized = false, outlet }: ProtectedProps) {
  return isAuthorized ? outlet : <NotAllowed />;
}
